module.exports = __webpack_public_path__ + "img/品質管理1-3.e8e254bb.png";